module.exports = __webpack_public_path__ + "static/experiences-2c000384cc3d5de66bd55901244b9620.png";